import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VAppBar,{attrs:{"app":"","color":"#00b1ca","dark":""}},[_c(VIcon,{attrs:{"large":""}},[_vm._v("mdi-dice-6")]),_c(VToolbarTitle,[_vm._v("dicer")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }